import { fontSans } from './settingsSectionSx.part01.js'

export const settingsItemTextPrimarySx = {
  fontSize: 'var(--app-font-size-md)',
  fontWeight: 500,
  lineHeight: '20px',
  color: 'var(--app-text-primary)',
  fontFamily: fontSans,
}
